import "./card.css";

export default function Card({
  title,
  children,
  style,
}: {
  title?: string | React.ReactNode;
  children: React.ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <div className="card" style={style}>
      {title && <h3>{title}</h3>}
      {children}
    </div>
  );
}
